import { Container } from 'ui/container'
import { TriggersList } from 'features/admin/triggers'

import c from '../assets/sass/page.module.scss'

const AdminTriggersPage = () => {
    return (
        <div className={c.component}>
            <div className={c.header}>
                <span className={c.title}>Триггеры</span>
            </div>
            <Container>
                <TriggersList />
            </Container>
        </div>
    )
}

export default AdminTriggersPage
